import * as React from 'react';
import { useSelector } from 'react-redux';
import { identity } from 'ramda';

import { Section } from '../../../components/Section';
import { MarketPriceContainer } from '../../MarketPriceContainer';
import { ValuationFiltersContainer } from '../../ValuationFiltersContainer';
import { SendReportContainer } from '../../SendReportContainer';

import { HeroResultSectionContainer } from '../../HeroResultSectionContainer';
import { StickyFooterContainer } from '../../StickyFooterContainer';
import { TabsContainer } from '../../TabsContainer';
import { NotificatorContainer } from '../../NotificatorContainer';
import { useIsReportStatusDefault } from '../../../utils/report';
import { AboutHomeContainer } from '../../AboutHomeContainer';
import { useScrollingRef } from '../../Scrolling';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { ValuationContentContainer } from '../../ValuationContentContainer';
import { OffersHistoryContainer } from '../../OfferHistory/Mobile';
import { selectDealType } from '../../../selectors/page';
import { EstimationDealTypeBannerContainer } from '../../EstimationDealTypeBannerContainer';
import { ObjectInfoContainer } from '../../ObjectInfoContainer';
import { selectEstimationByDealType } from '../../../selectors/estimation';
import { ErrorScreen } from '../../../components/ErrorScreen';
import { RateOurEstimationContainer } from '../../RateOurEstimationContainer';
import { MobileInfrastructureContainerLoad } from '../../InfrastructureMapContainer';

export function MobilePageContainer() {
  const isReportStatusDefault = useIsReportStatusDefault();
  const valuationFiltersRef = useScrollingRef(EScrollingBlocks.ValuationFilters);
  const marketPriceRef = useScrollingRef(EScrollingBlocks.MarketPrice);
  const offersHistoryRef = useScrollingRef(EScrollingBlocks.OffersHistory);
  const dealTypeTabsRef = useScrollingRef(EScrollingBlocks.DealTypeTabs);
  const infrastructureRef = useScrollingRef(EScrollingBlocks.Infrastructure);
  const aboutHomeRef = useScrollingRef(EScrollingBlocks.AboutHome);

  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));

  if (estimation.isError) {
    return <ErrorScreen />;
  }

  return (
    <>
      <HeroResultSectionContainer />
      <ValuationFiltersContainer refWrapper={valuationFiltersRef} />
      <ValuationContentContainer>
        <Section marginBottom={40}>
          <TabsContainer refWrapper={dealTypeTabsRef} />
          <EstimationDealTypeBannerContainer />
        </Section>
        <Section>
          <ObjectInfoContainer refWrapper={identity} />
        </Section>
        <Section marginTop={!isReportStatusDefault ? 52 : undefined} marginBottom={48}>
          <MarketPriceContainer refWrapper={marketPriceRef} />
          <RateOurEstimationContainer />
        </Section>
        <Section marginTop={48} marginBottom={48}>
          <OffersHistoryContainer refWrapper={offersHistoryRef} />
        </Section>
        <Section>
          <AboutHomeContainer refWrapper={aboutHomeRef} />
        </Section>
        <Section>
          <MobileInfrastructureContainerLoad refWrapper={infrastructureRef} />
        </Section>
        <Section>
          <SendReportContainer />
        </Section>
      </ValuationContentContainer>
      <StickyFooterContainer />
      <NotificatorContainer />
    </>
  );
}
